import Stack from '@mui/material/Stack'
import { useStoreState } from '../../../../store/hooks'
import ColorToMove from '../../components/ColorToMove'
import DailyPuzzleButtons from '../components/DailyPuzzleButtons'
import DailyPuzzleCharacter from '../components/DailyPuzzleCharacter'
import DailyPuzzleControls from '../components/DailyPuzzleControls'
import DailyPuzzleNotations from '../components/DailyPuzzleNotations'
import DailyPuzzleStreak from '../components/DailyPuzzleStreak'
import DailyPuzzleTitle from '../components/DailyPuzzleTitle'

const DesktopDP: React.FC = () => {
    const myColor = useStoreState((state) => state.dailyPuzzleViewV2.myColor)

    return (
        <Stack alignItems="center" spacing="12px" sx={{ flexGrow: 1 }}>
            {/* Title */}
            <DailyPuzzleTitle />
            {/* Streak */}
            <DailyPuzzleStreak />
            <Stack
                sx={{
                    flexGrow: 1,
                    minHeight: 0,
                    alignSelf: 'stretch',
                    borderRadius: '8px !important',
                }}
            >
                {/* Character */}
                <DailyPuzzleCharacter />
                {/* Notations */}
                <DailyPuzzleNotations />
            </Stack>
            {/* Color to Move */}
            <ColorToMove playerColor={myColor} />
            {/* Controls */}
            <DailyPuzzleControls />
            {/* Buttons */}
            <DailyPuzzleButtons />
        </Stack>
    )
}

export default DesktopDP
